import React, { Fragment } from 'react';

import type {
  BreakpointComponent,
  Component,
  ImageComponent,
  SubheadingComponent,
} from '../../../../../core/data-sources/content-components/types.js';
import type { SaveList, SaveListItem } from '../../../../types/save-types.js';

import ListicleNumber, {
  formatNumber,
} from '../articleComponents/Text/ListicleNumber.js';
import ComponentSelector from '../articleComponents/ComponentSelector.js';
import GroupDescription from '../articleComponents/GroupDescription.js';

export interface GroupProps {
  groupIndex: number;
  components: Component[];
  parentId: string;
  handleOverlay: (item: SaveListItem) => void;
  isMobile: boolean;
  savedItems: SaveList[];
  slug: string;
  articleTitle: string;
  isGuide?: boolean;
  showListicleNumber?: boolean;
}

export const Group: React.FC<GroupProps> = ({
  components,
  groupIndex,
  parentId,
  handleOverlay,
  isMobile,
  savedItems,
  slug,
  articleTitle,
  isGuide,
  showListicleNumber = true,
}) => {
  const image = components.find((c) => c.type === 'image');
  const groupItemTitle = (
    components.find((c) => c.type === 'subheading') as SubheadingComponent
  )?.text?.value;

  const groupItem: SaveListItem = {
    id: `${parentId}/#${formatNumber(groupIndex)}`,
    title: groupItemTitle,
    imageId: (image as ImageComponent)?.imageAsset?.id,
    slug,
    listicleId: formatNumber(groupIndex),
    kicker: articleTitle,
  };

  const filteredComponents = components.filter(
    (item) => showListicleNumber || item.type !== 'subheading',
  );

  const multipleRecommendations = () =>
    components.find((c) => c.presentationProperties?.intention === 'separator');

  let counter = 1;

  return (
    <div className="listicle-group">
      <GroupDescription item={components[0] as BreakpointComponent} />
      {!multipleRecommendations() && (
        <ListicleNumber
          key={`listicle-number-${parentId}-${groupIndex}`}
          number={groupIndex}
          groupItem={groupItem}
          handleOverlay={handleOverlay}
          savedItems={savedItems}
          showNumber={showListicleNumber}
          title={groupItemTitle}
        />
      )}
      {filteredComponents.map((item, index) => {
        const shouldRenderListicleNumber =
          multipleRecommendations() && item.type === 'subheading';

        const currentCounter = shouldRenderListicleNumber ? counter++ : counter;

        return (
          <Fragment key={index}>
            {shouldRenderListicleNumber && (
              <ListicleNumber
                key={`listicle-number-${parentId}-${groupIndex}`}
                number={currentCounter}
                groupItem={groupItem}
                handleOverlay={handleOverlay}
                savedItems={savedItems}
                showNumber={showListicleNumber}
                title={groupItemTitle}
              />
            )}
            <ComponentSelector
              item={item}
              index={index}
              articleTitle={articleTitle}
              isMobile={isMobile}
              isGuide={!!isGuide}
              key={index}
              groupIndex={groupIndex}
            />
          </Fragment>
        );
      })}
    </div>
  );
};
